import { CSSProperties } from 'react';

import { useTranslation } from 'react-i18next';

import { useGetLatestActivitiesQuery } from '@school_ify/schoolify-repository/src/shared/types';

import Card from 'components/Card/Card';
import useDeviceDetect from 'hooks/useDeviceDetect';
import liveClass from 'assets/icons/header/latest-activites.svg';

import ActivityItem from './components/ActivityItem/ActivityItem';

import './LatestStudentActivity.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
}

const LatestStudentActivity: React.FC<Props> = ({ style }) => {
  const { t } = useTranslation();
  const { isMobile } = useDeviceDetect();
  const latestActivities = useGetLatestActivitiesQuery();

  return (
    <div className="latest-chat-container" style={style}>
      <Card
        title={
          <>
            <img className="card-icon" src={liveClass} alt="message icon" />
            {t('common:latest_student_activity')}
          </>
        }
        foldable={isMobile}
      >
        {!isMobile && (
          <Card.Header>
            <img className="card-icon" src={liveClass} alt="message icon" />
            <h4 className="card-title">{t('common:latest_student_activity')}</h4>
            <div className="filler" />
            <div className="dropdown">
              {/* <CardDropDown>
                            {menu.map(menuItem => (
                                <div
                                    className="dropdown-element pointer"
                                    key={`${menuItem.name}-${menuItem.id}`}
                                >
                                    <ThemeCheckBox
                                        round
                                        label={menuItem.name}
                                        checked={active === menuItem.id}
                                        onChange={() => setActive(menuItem.id)}
                                    />
                                </div>
                            ))}
                        </CardDropDown> */}
            </div>
          </Card.Header>
        )}
        <Card.Body style={{ padding: '10px 24px' }}>
          {latestActivities?.data?.latest_activities.map(activity => {
            const { id, message, created_at, path } = activity;
            try {
              const parsedMessage = JSON.parse(message);
              return (
                <ActivityItem
                  key={id}
                  title={t(parsedMessage.message, parsedMessage.variables)}
                  date={created_at}
                  path={path}
                />
              );
            } catch (err) {
              console.error(err);
              return null;
            }
          })}
          {/* {latestActivities?.data?.latest_activities.map(activity => (
            <ActivityItem
              key={activity.id}
              title={activity.message}
              date={activity.created_at}
              path={activity.path}
            />
          ))} */}
          {/* <div className="show-more">
            <Button
              onClick={() => undefined}
              round
              outlined
              style={{
                backgroundColor: '#fff',
                border: '2px solid #5CD79E',
                width: '130px',
                fontSize: 15,
              }}
            >
              + Load more
            </Button>
          </div> */}
        </Card.Body>
      </Card>
    </div>
  );
};

export default LatestStudentActivity;
